import { render, staticRenderFns } from "./RocketTable.vue?vue&type=template&id=191aa9b4&"
import script from "./RocketTable.vue?vue&type=script&lang=js&"
export * from "./RocketTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports